import { gatewayServiceBaseUrl } from "lib/consts/arcGateway";
import { getAuthToken } from "lib/utils/auth";

/**
 * Build a URL to the ARC's mission_storage service (port 8000).
 *
 * Resolves the fleet proxy origin or the direct ARC origin. Fleet requests are
 * path-routed and never fall back to an ARC Tailscale address.
 */
export const buildArcStorageUrl = (
    path: string,
    opts: { isSecure: boolean; arcId?: string | null; arcProxyHost?: string | null }
): string => {
    const { isSecure, arcId, arcProxyHost } = opts;
    const host = arcProxyHost || process.env.REACT_APP_SINGLE_ARC_HOSTNAME || window.location.hostname;
    const gateway = gatewayServiceBaseUrl("missionStorage", arcId, arcProxyHost);
    if (arcId && !gateway) {
        throw new Error("Fleet proxy host is unavailable");
    }
    const u = new URL(
        gateway
            ? `${gateway}${path.startsWith("/") ? path : `/${path}`}`
            : `${isSecure ? "https" : "http"}://${host}:8000${path}`
    );
    const token = getAuthToken();
    if (token) u.searchParams.set("token", token);
    return u.toString();
};
